import {useRouter} from 'next/dist/client/router';
import React, {useEffect} from 'react';
import {useDispatch} from 'react-redux';

import {useMyOan} from '../../api/hooks/useMyOan.hook';
import creatoki from '../../assets/creatoki.png';
import {DefaultHeader} from '../../components/_shared/header/default-header/default-header';
import {HeaderFooterWrapper} from '../../components/_shared/header-footer-wrapper/header-footer-wrapper';
import {MetaTagsResolver} from '../../components/_shared/meta-tags-resolver/meta-tags-resolver';
import MyOanStage from '../../components/my-oan/my-oan-stage/my-oan-stage';
import MyOanTeaser from '../../components/my-oan/my-oan-teaser/my-oan-teaser';
import {RootState} from '../../redux';
import {fetchMyOanUser} from '../../redux/slices/my-oan.slice';
import {RoutePath} from '../../utils/_enums/route-path.enum';
import {useAppSelector} from '../../utils/_hooks/hooks';

const MyOan = () => {
    const data = useMyOan();
    const router = useRouter();
    const dispatch = useDispatch();
    const {user, fetchUserStatus} = useAppSelector((state: RootState) => ({
        user: state.myOanSlice.user,
        fetchUserStatus: state.myOanSlice.fetchStatus
    }));

    useEffect(() => {
        dispatch(fetchMyOanUser(router.query.username as string));
    }, []);

    useEffect(() => {
        if (fetchUserStatus && fetchUserStatus !== 200) {
            router.push(RoutePath.ERROR_PAGE);
        }
    }, [fetchUserStatus]);

    const metaTagTitle = () => {
        return data?.meta?.metaTagTitle && user?.username
            ? data.meta.metaTagTitle + user.username
            : '';
    }

    if (fetchUserStatus === 200) {
        return (
            <div>
                <MetaTagsResolver
                    tags={data?.meta}
                    title={metaTagTitle()}
                />
                <HeaderFooterWrapper
                    header={
                        <DefaultHeader
                            availableLanguages={data?.localizations}
                        />
                    }
                    stage={
                        <MyOanStage
                            username={user?.username ?? ''}
                            walletId={user?.wallet ?? ''}
                            description={user?.userDescription ?? ''}
                            decButton={{
                                image: user?.profileImageUrl ? user.profileImageUrl : creatoki.src
                            }}
                            titleVariant={data?.stage?.headline?.style}
                            socialNetworks={user?.socialNetworks ?? []}
                            background={data?.stage?.background?.url}
                            inverted={
                                data?.stage?.componentStyles?.inverted ?? false
                            }
                        />
                    }
                >
                    <MyOanTeaser/>
                </HeaderFooterWrapper>
            </div>
        );
    } else {
        return <div/>;
    }
};

export default MyOan;

MyOan.dataHooks = [
    ...HeaderFooterWrapper.dataHooks,
    useMyOan,
    ...MetaTagsResolver.dataHooks
];
